import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Row, Col, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { setHeaderTitle } from '../../actions/HeaderActions';
import SimpleBar from 'simplebar';
import { FormattedMessage } from 'react-intl';
import { sendData } from '../../analytics/sendData';

class ClaimGadget extends Component {

    componentDidMount() {
        sendData('', '', 'video', 'viewed', { page: 'claim gadget' });
        this.props.setHeaderTitle("Claim Gadget");
        window.scrollTo(0, 0);
        // var el = new SimpleBar(document.querySelector(".claim-gadget-inner"), { autoHide: false });
        // el.recalculate();
        // el.getScrollElement();
        // this.labelPosition();
    }

    // labelPosition() {
    //     const gadgetInputs = document.querySelectorAll(".gadget-input");
    //     gadgetInputs.forEach(function(gadgetInput) {
    //         const gadgetLabel = gadgetInput.nextElementSibling;
    //         if(gadgetInput.value.length > 1) {
    //             gadgetLabel.style.bottom = "60%";
    //         }
    //     });
    // }

    preventSubmit(e) {
        e.preventDefault();
    }

    render() {
        return(
            <section className="claim-gadget">
                <div className="claim-gadget-inner">
                    <Container>
                        <Row>
                            <Col xs="12">
                                <Form id="gadget-form" className="gadget-form" action="" method="post" onSubmit={this.preventSubmit}>
                                    <FormGroup>
                                        <div className="input-wrap">
                                            <Label className="gadget-label" for="first-name">
                                                <FormattedMessage id="firstName"
                                                    defaultMessage="First Name"
                                                />
                                            </Label>
                                            <Input className="gadget-input" type="text" name="first-name" id="first-name" placeholder="Enter First Name" />                                        
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        <div className="input-wrap">
                                            <Label className="gadget-label" for="last-name">
                                                <FormattedMessage id="lastName"
                                                    defaultMessage="Last Name"
                                                />
                                            </Label>
                                            <Input className="gadget-input" type="text" name="last-name" id="last-name" placeholder="Enter Last Name" />                                        
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        <div className="input-wrap">
                                            <Label className="gadget-label" for="email-address">
                                                <FormattedMessage id="emailAdd"
                                                    defaultMessage="Email Address"
                                                />
                                            </Label>
                                            <Input className="gadget-input" type="email" name="email-address" id="email-address" placeholder="Enter Email Address" />                                        
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        <div className="phone-number-group">
                                            <div className="country-code-wrap input-wrap">
                                                <Label className="" for="country-code">
                                                    <FormattedMessage id="code"
                                                        defaultMessage="Code"
                                                    />
                                                </Label>
                                                <Input className="gadget-input gadget-input--select" type="select" name="country-code" id="country-code">
                                                    <option value="+91">+91</option>
                                                    <option value="+92">+92</option>
                                                    <option value="+93">+93</option>
                                                </Input>                                            
                                            </div>
                                            <div className="phone-number-wrap input-wrap">
                                                <Label className="label-block" for="phone-number">
                                                    <FormattedMessage id="phone"
                                                        defaultMessage="Phone Number"
                                                    />
                                                </Label>
                                                <Input className="gadget-input" type="text" name="phone-number" id="phone-number" placeholder="Enter Phone Number" />                                            
                                            </div>
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        <div className="input-wrap">
                                            <Label className="gadget-label gadget-label--select" for="country">
                                                <FormattedMessage id="country"
                                                    defaultMessage="Country"
                                                />
                                            </Label>
                                            <Input className="gadget-input gadget-input--select" type="select" name="country" id="country">
                                                <option style={{display: "none"}}>
                                                    <FormattedMessage id="pickYourCountry"
                                                        defaultMessage="Pick your Country"
                                                    />
                                                </option>                                         
                                                <option value="Malaysia">Malaysia</option>
                                                <option value="India">India</option>
                                                <option value="UK">UK</option>
                                            </Input>                                        
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        <div className="input-wrap">
                                            <Label className="gadget-label gadget-label--select" for="state">
                                                <FormattedMessage id="state"
                                                    defaultMessage="State"
                                                />
                                            </Label>
                                            <Input className="gadget-input gadget-input--select" type="select" name="state" id="state">
                                                <option style={{display: "none"}}>
                                                    <FormattedMessage id="pickYourState"
                                                        defaultMessage="Pick your State"
                                                    />
                                                </option>
                                                <option value="State 1">State 1</option>
                                                <option value="State 2">State 2</option>
                                                <option value="State 3">State 3</option>
                                            </Input>                                        
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        <div className="input-wrap">
                                            <Label className="gadget-label" for="address">
                                                <FormattedMessage id="address"
                                                    defaultMessage="Address"
                                                />
                                            </Label>
                                            <Input className="gadget-input" type="text" name="address" id="address" placeholder="Enter Address" />                                        
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        <div className="input-wrap">
                                            <Label className="gadget-label" for="zip-code">
                                                <FormattedMessage id="zipCode"
                                                    defaultMessage="Zip Code"
                                                />
                                            </Label>
                                            <Input className="gadget-input" type="text" name="zip-code" id="zip-code" placeholder="Enter Zip Code" />                                        
                                        </div>
                                    </FormGroup>
                                    <div className="submit-btn-wrap">                                
                                        <button type="submit" className="btn-unstyled submit-btn">
                                            <FormattedMessage id="submit"
                                                defaultMessage="Submit"
                                            />
                                        </button>
                                    </div>
                                </Form>
                            </Col>
                        </Row>
                    </Container>                  
                </div>
            </section>
        )
    }

}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setHeaderTitle
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ClaimGadget);


// WEBPACK FOOTER //
// ./src/components/ClaimGadget/ClaimGadget.js